export const LOAD_PRODUCTS_REQUEST = 'MerchantProductsPage/LOAD_PRODUCTS_REQUEST';
export const LOAD_PRODUCTS_SUCCESS = 'MerchantProductsPage/LOAD_PRODUCTS_SUCCESS';
export const LOAD_PRODUCTS_ERROR   = 'MerchantProductsPage/LOAD_PRODUCTS_ERROR';
